import { useTranslation } from "react-i18next";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";
import { CANDIDATE_FIELDS } from "@/types/queryBuilder";

interface FieldSelectorProps {
	value: string;
	onChange: (field: string) => void;
}

export function FieldSelector({ value, onChange }: FieldSelectorProps) {
	const { t } = useTranslation();

	return (
		<Select value={value} onValueChange={onChange}>
			<SelectTrigger className="w-[160px]">
				<SelectValue placeholder={t("queries.selectField", "Select field")} />
			</SelectTrigger>
			<SelectContent>
				{CANDIDATE_FIELDS.map((field) => (
					<SelectItem key={field.key} value={field.key}>
						{t(`queries.fields.${field.key}`, field.label)}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
}
